export const MENTION_REMINDERS_ONBOARDING_STATE_KEYS = {
	ANALYTICS_BYLINE_NUDGE_SEEN: 'mention-reminders:wasAnalyticsBylineNudgeSeen',
	MENTION_REMINDERS_BUTTON_NUDGE_SEEN: 'mention-reminders:wasMentionRemindersButtonNudgeSeen',
};
